import React, { useEffect, useState, useRef } from 'react';
import Tile from 'components/Tile/Tile';
import Loader from 'components/Loader/Loader';
import { ContentFragment, CategoryFragment } from 'generated/graphql';

import s from './CategoryItems.module.scss';

interface ICategoryItems {
  category: CategoryFragment;
  alias: string;
  title?: string;
  fetchMore: (category: CategoryFragment) => void;
}

const CategoryItems = ({
  category, title, alias, fetchMore,
}: ICategoryItems) => {
  const [showLoader, setShowLoader] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setShowLoader(true);
    const loadMore = () => {
      if (contentRef?.current) {
        const contentBottom = +contentRef?.current?.offsetTop + +contentRef?.current?.offsetHeight;
        const windowScroll = window.scrollY + document.documentElement.clientHeight;

        if ((windowScroll >= contentBottom) && fetchMore) {
          fetchMore(category);
        }
      }
    };
    if (category?.contents?.length && category.totalContent > category.contents.length) {
      window.addEventListener('scroll', loadMore);
    } else {
      setShowLoader(false);
    }
    return () => {
      window.removeEventListener('scroll', loadMore);
    };
  }, [category.contents?.length]);

  return (
    <>
      {title && (
        <div className="container">
          <h1 className={s.Title}>{title}</h1>
        </div>
      )}
      <div className={s.CategoryItems} ref={contentRef}>
        {category?.contents && category.contents
          ?.map((item: ContentFragment, index) => {
            const isBig = index === 0 || index === 7;
            return (
              <Tile
                data={item}
                isBig={isBig}
                index={index}
                alias={alias}
                key={item.id}
              />
            );
          })}
        {showLoader && (
        <div className={s.LoaderWrapper}>
          <Loader />
        </div>
        )}
      </div>
    </>
  );
};

CategoryItems.defaultProps = {
  title: '',
};

export default CategoryItems;
